import { isPostingPlan } from './finishSetup.js';
import { freePublishingState } from './freePublishing.js';

export function postingFeatureForPath(pathname = '') {
  if (pathname === '/app/plan' || pathname.startsWith('/app/plan/')) return 'plan';
  if (pathname === '/app/research' || pathname.startsWith('/app/research/')) return 'marketing';
  if (pathname === '/app/marketing' || pathname.startsWith('/app/marketing/')) return 'marketing';
  return null;
}

export function postingLockedSection({ pathname = '', entitlements = null } = {}) {
  const feature = postingFeatureForPath(pathname);
  // Free includes the research snapshot, not ongoing planning/strategy.
  return feature && (isPostingPlan(entitlements)
    || (feature === 'plan' && freePublishingState(entitlements))) ? feature : null;
}
